import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import {
  PickingBoxInterface,
  PickingBoxTypeInterface,
  PickingBoxTmsServicesResponseInterface,
} from "../../../../redux/interfaces/inventory.interface";
import { DropdownValue } from "../../../../components/misc/Dropdown";

export const getPickingBoxTypeOptions = (response: unknown): DropdownValue[] =>
  ((response as PickingBoxTypeInterface[] | null) ?? []).map((item) => ({
    id: item.tip,
    label: item.denumire,
  }));

export const getPickingBoxTmsOptions = (response: unknown): DropdownValue[] =>
  ((response as PickingBoxTmsServicesResponseInterface | null)?.data ?? []).map(
    (item) => ({
      id: item.tip_ambalaj,
      label: item.denumire,
    }),
  );
export const pickingBoxesTableHeader: TableHeaderCategoryConfig[] = [
  { value: "nume", label: "Denumire ambalaj", minW: 125 },
  { value: "dimensiuni", label: "Dimensiuni", minW: 125 },
  { value: "greutate", label: "Greutate", minW: 125 },
  { value: "stock", label: "Stoc", minW: 125 },
  { value: "Op", label: "Nr. comanda", minW: 125 },
  { value: "tip", label: "Material", minW: 125 },
  { value: "tip_tms", label: "Tip TMS", minW: 125 },
];

export const getPickingBoxesTableData = (
  items: PickingBoxInterface[],
  types: DropdownValue[],
  tmsTypes: DropdownValue[],
) =>
  items.map((item) => ({
    id: item.idCutie,
    crudData: item,
    data: [
      { title: item.nume },
      { title: item.dimensiuni },
      { title: item.greutate },
      { title: item.stock },
      { title: item.Op ?? "-" },
      {
        title:
          types.find((type) => String(type.id) === String(item.tip))?.label ??
          "-",
      },
      {
        title:
          tmsTypes.find((type) => String(type.id) === String(item.tip_tms))
            ?.label ?? "-",
      },
    ],
  }));
